import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import TextField from  '../components/shared/ppbn-textfield';
import ValidatePasswordField from '../components/shared/validate-password-textfield';

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
    },
    textField: { 
        paddingBottom: '.75rem',
    },
    validatePasswordField : {     
        minHeight: '110px',
    }
};

export class NewPasswordSection extends Component {
    
    render() {
        const { classes, newPassword } = this.props; 
        return (<div className={classes.container}>
                <ValidatePasswordField
                    value={newPassword}
                    className={classNames('new-password', classes.validatePasswordField)}
                    type="password"
                    label="New Password"
                    onChange={(event) => this.props.onChange({ newPassword: event.target.value }) } />
                <br />
                <TextField
                    className={classNames('confirm-new-password', classes.textField)}
                    type="password"
                    label="Confirm New Password"
                    onChange={(event) => this.props.onChange({ confirmNewPassword: event.target.value })} />
                <br />
                <TextField
                className={classNames('first-name', classes.textField)}
                    label="First Name"
                    onChange={(event) => this.props.onChange({ firstname: event.target.value })}/>
                <br />
            </div>)
    }
}

export default withStyles(styles)(NewPasswordSection);